import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AgendasService } from 'src/app/Services/Agendas/agendas.service';
import { AuthService } from 'src/app/Services/AuthService/auth-service.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit  {

  currentTab=''
  constructor(public router:Router, public _authService:AuthService , private agendaService: AgendasService) { }
  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((even: any) =>  {
      this.currentTab =even.url;
    });;
  }
  isExpanded = false;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  logout(){
    this._authService.doLogoutUser(true)
    this.agendaService.clearAll()
  }

  // [DEV — ADA Analysis] Navigates to the registered-agent page (if not already there),
  // switches to the Upload Evidence tab, and fires an rp-dev-dialog-preview event so
  // UploadComponent renders the requested dialog/state for ADA inspection.
  public dispatchDialogScenario(scenario: string): void {
    if (this.router.url.includes('registered-agent')) {
      // Already on the page — dispatch a tab-select event then, after Kendo has switched
      // tabs and UploadComponent has initialised, fire the scenario event.
      window.dispatchEvent(new CustomEvent('rp-dev-tab-select', { detail: 3 }));
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('rp-dev-dialog-preview', { detail: scenario }));
      }, 500);
    } else {
      // Not on the page — persist both pieces to sessionStorage so they are read
      // by RegisteredAgentComponent.ngOnInit and UploadComponent.ngOnInit after navigation.
      sessionStorage.setItem('rp-dev-target-tab', '3');
      sessionStorage.setItem('rp-dev-scenario', scenario);
      this.router.navigateByUrl('registered-agent');
    }
  }

  // [DEV — ADA Analysis] Triggers the PA Upload Completed dialog (success state with Axia prompt).
  previewPAUploadCompleted() {
    this.dispatchDialogScenario('pa-upload-completed');
  }

  // [DEV — ADA Analysis] Triggers one of the Axia Transfer dialog states:
  //   eligible-selected      — petitions eligible, at least one checked
  //   eligible-none-selected — petitions eligible, none checked
  //   expired                — all petition deadlines have passed
  //   processing             — upload still in flight (spinner state)
  previewAxiaScenario(caseName: 'eligible-selected' | 'eligible-none-selected' | 'expired' | 'processing') {
    this.dispatchDialogScenario(`axia-${caseName}`);
  }

  openPDFNewWindow() {
    if(window.location.origin.includes('localhost')){
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['pdf-viewer'])
      );
      window.open("/#"+url, '_blank');
    }
    else{
      const url = this.router.serializeUrl(
        this.router.createUrlTree([ (window.location.href.includes('_Multi_Test'))? `/PAOnlineTools/Registration_Portal_Client_Multi_Test/pdf-viewer`
        :`/PAOnlineTools/RegistrationPortalClient/pdf-viewer`])
      );
      window.open(url.replace("/pdf-viewer","/#/pdf-viewer"), '_blank');//here make change
    }
  }
}
